import {
  Code,
  Header,
  Image,
  PageHeader,
  Paragraph,
  TextInfoPage,
} from "../../components/Page";
import CountingOverviewSvg from "./../../img/CountingOverview.svg";
import {useTranslation} from "react-i18next";

export default function GlossaryPage() {
  const { t } = useTranslation();
    
  const P = Paragraph;
  const H = Header;

  return (
    <TextInfoPage>
      <PageHeader>{ t("glossaryPage.title") }</PageHeader>
      <Image src={CountingOverviewSvg} title="Infographic" />
      <H>{ t("glossaryPage.paragraphs.actualSpeed.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.actualSpeed.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.availability.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.availability.text") }
        <Code>{ t("glossaryPage.paragraphs.availability.formula") }</Code>
      </P>
      <H>{ t("glossaryPage.paragraphs.averageSetSpeed.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.averageSetSpeed.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.averageSpeed.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.averageSpeed.text") }
          <Code>{ t("glossaryPage.paragraphs.averageSpeed.formula") }</Code>
          { t("glossaryPage.paragraphs.averageSpeed.example") }
      </P>
      <H>{ t("glossaryPage.paragraphs.bloodDetector.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.bloodDetector.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.bloodEggs.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.bloodEggs.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.bucketEggs.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.bucketEggs.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.bypassEggs.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.bypassEggs.text") }.
      </P>
      <H>{ t("glossaryPage.paragraphs.capacityUtilization.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.capacityUtilization.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.carrier.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.carrier.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.crackDetector.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.crackDetector.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.designatedBreakTime.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.designatedBreakTime.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.designatedSpeed.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.designatedSpeed.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.detectionSystems.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.detectionSystems.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.downgradedEggs.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.downgradedEggs.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.downSizing.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.downSizing.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.downTime.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.downTime.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.downTyping.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.downTyping.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.eggInspector.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.eggInspector.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.eggType.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.eggType.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.endEggs.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.endEggs.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.errorCategories.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.errorCategories.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.fillrate.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.fillrate.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.gradeAEggs.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.gradeAEggs.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.inputCracks.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.inputCracks.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.inputDirts.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.inputDirts.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.inputGradeA.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.inputGradeA.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.inputOffgrades.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.inputOffgrades.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.leakDetector.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.leakDetector.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.leakerEggs.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.leakerEggs.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.lifesign.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.lifesign.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.mobaAvailability.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.mobaAvailability.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.netProductionTime.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.netProductionTime.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.netThroughput.header") }</H>
      <P>
          <Code>{ t("glossaryPage.paragraphs.netThroughput.formula") }</Code>
      </P>
      <H>{ t("glossaryPage.paragraphs.oee.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.oee.abbreviation") }
          <Code>{ t("glossaryPage.paragraphs.oee.formula") }</Code>
          { t("glossaryPage.paragraphs.oee.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.offgrades.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.offgrades.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.outputCracks.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.outputCracks.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.outputDirts.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.outputDirts.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.outputOffgrades.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.outputOffgrades.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.overUnderWeights.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.overUnderWeights.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.pauseTime.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.pauseTime.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.performance.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.performance.text") }
        <Code>{ t("glossaryPage.paragraphs.performance.formula") }</Code>
      </P>
      <H>{ t("glossaryPage.paragraphs.productionTime.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.productionTime.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.quality.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.quality.text") }
        <Code>{ t("glossaryPage.paragraphs.quality.formula") }</Code>
      </P>
      <H>{ t("glossaryPage.paragraphs.rejectedEggs.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.rejectedEggs.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.runHours.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.runHours.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.sellableProduct.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.sellableProduct.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.setSpeed.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.setSpeed.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.softwareVersions.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.softwareVersions.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.spareLane.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.spareLane.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.supplyDestinations.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.supplyDestinations.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.tableEggs.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.tableEggs.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.takeawayOffgrades.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.takeawayOffgrades.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.teep.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.teep.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.throughput.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.throughput.text") }
        <Code>{ t("glossaryPage.paragraphs.throughput.formula") }</Code>
      </P>
      <H>{ t("glossaryPage.paragraphs.totalEggs.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.totalEggs.text") }
        <Code>{ t("glossaryPage.paragraphs.totalEggs.formula") }</Code>
      </P>
      <H>{ t("glossaryPage.paragraphs.track.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.track.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.upgradeUtilization.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.upgradeUtilization.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.upgradedEggs.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.upgradedEggs.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.upgrading.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.upgrading.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.upsizing.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.upsizing.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.uptime.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.uptime.text") }
      </P>
      <H>{ t("glossaryPage.paragraphs.uptyping.header") }</H>
      <P>
          { t("glossaryPage.paragraphs.uptyping.text") }
      </P>
    </TextInfoPage>
  );
}
